<template>
    <Icons.TILegalMinBase class="fill-current text-red-600"></Icons.TILegalMinBase>
</template>

<script setup>
import Icons from '../../Icons.js';
</script>
